
import verifyLabel from '../../../methods/verifyLabel'

export default {
    name: 'configurator-tablist',
    data(){
        return {
            isHardware: false,
            hasSingleLicenseType: false,
            selectedLevelOne: null,
            selectedLevelTwo: null,
            amount: 0,
            allIsSelected: false,
            configuratorType: "",
            priceText: "",
            priceDiscountedText: "",
            LevelOne: null,
            productHasDiscount: false,
            selectedProductId: null,
        }
    },
    computed:{
        LevelTwoData(){
            let returnData = null
            if (this.LevelOne) {
                returnData = this.LevelOne.find(item => item.id === this.selectedLevelOne)
            }
            return returnData ? returnData.levelTwo : []
        },
        labels() {
            return this.$store.state.main.labels
        },
        showNextRow() {
            if (this.isHardware || this.selectedLevelTwo && this.selectedLevelOne) {
                return true
            } 
        }
    },
    methods: {
        activateLevelOne(LevelOneID) {
            this.selectedProductId = null
            this.selectedLevelTwo = null
            this.amount = 1
            this.selectedLevelOne = LevelOneID === this.selectedLevelOne ? null : LevelOneID
            this.$store.commit("main/setLevelOneID", {id : this.selectedLevelOne})
        },
        chooseLevelTwo(LevelTwoID, productId) {
            this.selectedLevelTwo = LevelTwoID === this.selectedLevelTwo ? null : LevelTwoID
            this.selectedProductId = productId
            //Track view of variant
            let _paq = window._paq = window._paq || [];
            this.LevelTwoData.forEach(item => {
                if (item.id === LevelTwoID) {
                    _paq.push(['setEcommerceView', item.name, item.trackingName ?? item.displayName, this.configuratorType, item.priceAmount]);
                    if (this.LevelTwoData.length > 1) {
                        //Don't do an extra pageview if there is only one variant
                        _paq.push(['trackPageView']);
                    }
                }
            });
            //Normal handling of product configurator
            if (this.configuratorType === 'Product') {
                this.LevelTwoData.forEach(item => {
                    if (item.id === LevelTwoID) {
                        this.priceText = item.priceText
                        this.checkForDiscount(item.priceDiscountedText)
                    }
                }) 
                this.$store.commit("main/setLevelTwoID", {id : this.selectedLevelTwo})
            } else {
                this.priceText = this.$store.state.main.productConfiguratorSettings.priceFromText
                this.checkForDiscount(this.$store.state.main.productConfiguratorSettings.priceFromDiscountedText)
            }
        },
        checkForDiscount(discountedText) {
            if (discountedText) {
                this.productHasDiscount = true
                this.priceDiscountedText = discountedText
            } else {
                this.productHasDiscount = false
            }
        },
        incrementAmount() {
            this.amount += 1
            this.$store.commit("main/setAmount", {amount : this.amount})
        },
        decrementAmount() {
            this.amount = this.amount ? this.amount-1 : 0
            this.$store.commit("main/setAmount", {amount : this.amount})
        },
        changeAmount() {
            const newAmount = Number.isInteger(+this.amount) ? +this.amount : 0
            this.amount = newAmount
            this.$store.commit("main/setAmount", {amount : this.amount})
        },
        addToCart() {
            const payload = {
                code : this.selectedProductId,
                quantity : this.amount,
            }
            this.$store.dispatch("main/addToCart", payload)
        },
        enableAddToBasketforHardware() {
            if (this.isHardware && this.amount) {
                this.allIsSelected = true
            } 
        },
        enableAddToBasketforCourseOrSoftware() {
            if (this.selectedLevelOne && this.selectedLevelTwo && this.amount) {
                this.allIsSelected = true
            } else {
                this.allIsSelected = false
            }
        },
        preSelectItemWhenOnlyOneIsPresent() {
            if (this.LevelOne.length === 1) {
                this.activateLevelOne(this.LevelOne[0].id)
                if (this.LevelOne[0].levelTwo.length === 1) {
                    this.chooseLevelTwo(this.LevelOne[0].levelTwo[0].id, this.LevelOne[0].levelTwo[0].name)
                }
            }
        },
        checkIfSoftwareHasNoLicenseType(type, levelOne) {
            this.hasSingleLicenseType = (levelOne[0].name === undefined && type === 'Product')
        },
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName,this.$store.state.main.labels)
            } else {
                return ""
            }
        }
    },
    mounted: function() {
        const settings = this.$store.state.main.productConfiguratorSettings
        const levelOneData = settings && settings.LevelOne ? settings.LevelOne : []

        this.LevelOne = levelOneData.map((item, levelOneIndex) => {
           return {
               name : item.name,
               displayName : item.displayName,
               levelTwo : item.levelTwo.map((item, levelTwoIndex) => {
                   return {
                        name : item.name,
                        displayName : item.displayName,
                        labelName : item.labelName,
                        priceAmount: item.priceAmount,
                        trackingName: item.trackingName,
                        priceText : item.priceText,
                        priceDiscountedAmount : item.priceDiscountedAmount,
                        priceDiscountedText : item.priceDiscountedText,
                        id : levelTwoIndex+1
                   }
               }),
               id : levelOneIndex+1
           }
        })
        this.configuratorType = settings ? settings.configuratorType : ""

        if (this.configuratorType === 'Hardware') {
            this.isHardware = true
            this.priceText = settings.priceFromText
        }

        if (this.LevelOne.length) {
            this.checkIfSoftwareHasNoLicenseType(this.configuratorType, this.LevelOne)
            this.preSelectItemWhenOnlyOneIsPresent()
        }
    },
    updated() {
        if (this.configuratorType === 'Hardware') {
            this.enableAddToBasketforHardware()
        } else {
            this.enableAddToBasketforCourseOrSoftware()
        }
    },
}